import {Injectable} from "@angular/core";
import {DxEncryptionStrategy} from "./dx-encryption-strategy";
import {DxLogger} from "../dx-logger.service";


// TODO: Понять что не так с этим функциями.
// TODO: В сети пишут что они объявлены deprecated.
// TODO: При использовании их в коде идея подсвечивает их красным как "Unresolved function".
// TODO: Но при этом ошибки компиляции не происходить.
// TODO: При импорте этих функций из querystring они почему-то воспринимаются не как функции а как объекты.
declare function unescape(s:string): string;
declare function escape(s:string): string;

/**
 * Дамми-стратегия шифрования\дешифрования данных при помощи алгоритмов `btoa`\`atob`.
 * Реализована для демонстрации принципа использования.
 * @publicApi
 */
@Injectable()
export class DxBasicEncryptionStrategy implements DxEncryptionStrategy {
  /**
   * Создает инстанс базовой стратегии шифрования.
   * @constructor
   * @param {DxLogger} _logger - логгер.
   */
  constructor(private _logger: DxLogger) { }


  /**
   * Осуществляет шифрование данных на основе алгоритма `btoa`.
   * @param {any} data - объект данных произвольного типа, подлежащий зашифровке.
   * @return {string} - строка с зашифрованными данными или `null` в случае ошибки.
   * @public
   */
  // TODO: Подумать на каком уровне ловить исключения
  public encrypt(data: any): string {
    try {
      let str = JSON.stringify(data);
      str = encodeURIComponent(str);
      str = unescape(str);
      return btoa(str);
    } catch (e) {
      this._logger.debug('Вызов DxBasicEncryptionStrategy.encrypt(...) завершился ошибкой: ');
      this._logger.debug(e);
    }
    return null;
  }


  /**
   * Осуществляет дешифрование данных на основе алгоритма `atob`.
   * @param {string} hash - строка с зашифрованными данными.
   * @return {any} - `JSON`-объек дешифрованных данных или `null` в случае ошибки.
   * @public
   */
  // TODO: Подумать на каком уровне ловить исключения
  public decode(hash: string): any {
    try {
      let str = atob(hash);
      str = escape(str);
      str = decodeURIComponent(str);
      return JSON.parse(str);
    } catch (e) {
      this._logger.debug('Вызов DxBasicEncryptionStrategy.decode(...) завершился ошибкой: ');
      this._logger.debug(e);
    }
    return null;
  }
}
